import React from "react";
import researchCircle1 from "../../images/research-circle-1.png";
import researchCircle2 from "../../images/research-circle-2.png";
import researchCircle3 from "../../images/research-circle-3.png";
import researchBg from "../../images/research-bg.png";

const ResearchInfo = () => {
  const isMobile = window.innerWidth < 768;
  const isTablet = window.innerWidth >= 768 && window.innerWidth < 1200;
  const isDesktop = window.innerWidth >= 1200;

  const circleSize = isMobile ? "180px" : "234px";
  const titleSize = isMobile ? "26px" : "32px";
  const descSize = isMobile ? "16px" : "20px";
  const cardWidth = isMobile ? "100%" : isTablet ? "320px" : "428px";

  return (
    <div
      className="pricing-page section-padding"
      style={{ position: "relative", overflow: "hidden", background: "#fff" }}
    >
      {/* 배경 이미지 - 카드 영역 뒤에 배치 */}
      <div
        style={{
          position: "absolute",
          top: isMobile ? "45%" : "55%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: isMobile ? "150%" : "80%",
          maxWidth: "1200px",
          height: "auto",
          zIndex: 0,
          pointerEvents: "none",
        }}
      >
        {isDesktop && (
          <img
            src={researchBg}
            alt=""
            style={{ width: "100%", height: "auto", marginBottom: "100px" }}
          />
        )}
      </div>
      <div className="container" style={{ position: "relative", zIndex: 1 }}>
        <div style={{ marginBottom: isMobile ? "40px" : "60px" }}>
          <h2
            style={{
              fontSize: isMobile ? "28px" : "40px",
              fontWeight: "700",
              marginBottom: "20px",
              color: "#313337",
              lineHeight: "150%",
              letterSpacing: "-0.05em",
            }}
          >
            폐수, 폐기물에서 자원화를 실현하는 {isMobile && <br />}
            종합환경전문기업
          </h2>
          <p
            style={{
              fontSize: isMobile ? "16px" : "18px",
              color: "#000",
              lineHeight: "180%",
              letterSpacing: "-0.05em",
            }}
          >
            ㈜엠알메탈로는 폐수, 폐기물에서 자원화를 실현하는
            종합환경전문기업으로써 끊임없는 변화와 도전정신을 갖춘 미래를
            {!isMobile && <br />}
            함께할 역량 있는 인재를 모십니다.
          </p>
        </div>
        <div
          style={{
            display: "flex",
            gap: isMobile ? "40px" : "22px",
            justifyContent: "center",
            flexWrap: isDesktop ? "nowrap" : "wrap",
            flexDirection: isMobile ? "column" : "row",
            alignItems: isMobile ? "center" : "flex-start",
          }}
        >
          {/* 개발 카드 */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "24px",
              width: cardWidth,
              maxWidth: "100%",
            }}
          >
            <img
              src={researchCircle1}
              alt="개발"
              style={{
                width: circleSize,
                height: circleSize,
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
            <h3
              style={{
                fontSize: titleSize,
                fontWeight: "700",
                color: "#313337",
                textAlign: "center",
                letterSpacing: "-0.05em",
                margin: "0",
              }}
            >
              개발
            </h3>
            <p
              style={{
                fontSize: descSize,
                color: "#000",
                textAlign: "center",
                lineHeight: "1.8",
                letterSpacing: "-0.05em",
                margin: "0",
              }}
            >
              <span style={{ fontWeight: "700" }}>
                수산화철 흡착제 원료 개발
              </span>
              <br />
              염화철 + 알칼리를 이용한 악취 제거용
              <br />
              흡착제 수산화철 개발
              <br />
              <br />
              <span style={{ fontWeight: "700" }}>
                이차전지 소재 분리 및 금속 추출기술 확립
              </span>
              <br />
              산/ 알칼리/ 용매추출을 이용한
              <br />
              금속 침출 및 분리 개발
              <br />
              <br />
              <span style={{ fontWeight: "700" }}>
                전기분해에 의한 금속 채취
              </span>
            </p>
          </div>

          {/* 연구 카드 */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "24px",
              width: cardWidth,
              maxWidth: "100%",
            }}
          >
            <img
              src={researchCircle2}
              alt="연구"
              style={{
                width: circleSize,
                height: circleSize,
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
            <h3
              style={{
                fontSize: titleSize,
                fontWeight: "700",
                color: "#313337",
                textAlign: "center",
                letterSpacing: "-0.05em",
                margin: "0",
              }}
            >
              연구
            </h3>
            <p
              style={{
                fontSize: descSize,
                color: "#000",
                textAlign: "center",
                lineHeight: "1.8",
                letterSpacing: "-0.05em",
                margin: "0",
              }}
            >
              <span style={{ fontWeight: "700" }}>
                한국생산기술연구원 지원과제
              </span>
              <br />
              고순도 몰리브덴 생산 연구
              <br />
              몰리브덴을 활용한 스테인레스 합금제
              <br />
              부원료 적용 TEST
              <br />
              <br />
              <span style={{ fontWeight: "700" }}>
                폐수 • 폐기물 자원화 방안 연구
              </span>
              <br />
              리튬, 타이타늄, 지르코늄, 탄탈 등<br />
              희유금속 자원화
            </p>
          </div>

          {/* 분석 카드 */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "24px",
              width: cardWidth,
              maxWidth: "100%",
            }}
          >
            <img
              src={researchCircle3}
              alt="분석"
              style={{
                width: circleSize,
                height: circleSize,
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
            <h3
              style={{
                fontSize: titleSize,
                fontWeight: "700",
                color: "#313337",
                textAlign: "center",
                letterSpacing: "-0.05em",
                margin: "0",
              }}
            >
              분석
            </h3>
            <p
              style={{
                fontSize: descSize,
                color: "#000",
                textAlign: "center",
                lineHeight: "1.8",
                letterSpacing: "-0.05em",
                margin: "0",
              }}
            >
              <span style={{ fontWeight: "700" }}>
                유도결합 플라즈마 분광 분석기
              </span>
              <br />
              (ICP-OES)를 통한 무기물의 정량분석
              <br />
              <br />
              <span style={{ fontWeight: "700" }}>
                폐수에 포함된 수질오염지표 분석
              </span>
              <br />
              <br />
              <span style={{ fontWeight: "700" }}>
                고객사의 의뢰에 따른 분석자료 제공
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResearchInfo;
